import React, { useEffect, useRef, useState } from 'react';
import Slider from "react-slick";
import '../css/Carousel.css';
import { showPrice } from '../utils/showPrice';
import noImage from '../images/no_image.jpg';
import Wishlisted from "../components/property/Wishlisted";

import { Link } from 'react-router-dom';
import generateSlug from './common/generateSlug';
import AlertModal from './modals/AlertModal';

const CommercialLease = ({premiumProjects,user,token,wishlist,handleDispatch}) => {

const [showAlertModal, setShowAlertModal] = useState(false);
  const handleOpenModal = () => {
  setShowAlertModal(true);

  // Auto close after 2 seconds
  setTimeout(() => {
    setShowAlertModal(false);
  }, 1500);
};
                
  const premRef = useRef(null);
     // Premium Projects
  const premiumpro = {
    dots: false,
   infinite:false,
    speed: 1000,
    autoplay: false,
    pauseOnHover: true,
    slidesToShow: 3,

    arrows: null,
    initialSlide: 0,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
         
       
          dots: true,
          arrows: false
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
          dots: true,
          arrows: false
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          arrows: false
        }
      }
    ]
  };

  const handlePrevClick2 = () => {
    if (premRef.current) {
      premRef.current.slickPrev();
    }
  };
  const handleNextClick2 = () => {
    if (premRef.current) {
      premRef.current.slickNext();
    }
  };

 const handleLinkClick = (project) => {
    const url = generateSlug(project);
    const propertyIds = project?.property_ids;
    localStorage.setItem('last-property-seen', JSON.stringify({ id: propertyIds, typeWithId: url }))
    window.location.href = url; // Navigate manually
  };


  //alert(JSON.stringify(premiumProjects))
            return (
        <>
{premiumProjects?.length > 0 && (
      <section className="afford-section sectiontopgap">
        <div className="container">
          <div className="sectiontitle">
      
            <div className="titleunderline" data-aos='fade-right'>
              <svg width="64" height="3" viewBox="0 0 64 3" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2 1.5H62" stroke="#EB622E" stroke-width="3" stroke-linecap="round" />
              </svg>

            </div>
            <h1 data-aos='fade-left'>Explore our Commercial Projects for Lease</h1>
          </div>

          <div className="slider-controls">
            <button className="slider-btn prev-btn" onClick={handlePrevClick2}>
              ❮
            </button>
            <Link to={'/commercial/lease/searches/property-in-jaipur-rajasthan-srcid-1'} ><button className="view-all-btn">VIEW ALL</button></Link>
            <button className="slider-btn next-btn" onClick={handleNextClick2}>
              ❯
            </button>
          </div>

          <div className='premium_content content_margin'>
          <Slider ref={premRef} {...premiumpro}>
          {premiumProjects?.length > 0 && (
                premiumProjects?.map((premproject, index) => (
            
            <div className="commercialLease-box" style={{width:"97%"}}   key={index} >
            <div className="commercialLease-slides">
              <div className="primdata">
                <div className="commertop">
                  <div className='commercialLeaseTop'>
                    <div className="commertitle">
                    <h4>{premproject?.project_name}</h4>
                    </div>
                    {/* <div className="commerprice d-flex gap-2">
                    <Wishlisted  data={premproject} wishlist={wishlist} user={user} token={token} handleDispatch={handleDispatch}/>
                    </div> */}
                  </div>
                </div>

                <div className="primmid">
                  <p className='commercialLeaseloc'>
                    <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M4 0.888672C1.77778 0.888672 0 2.66645 0 4.88867C0 7.11089 4 13.3331 4 13.3331C4 13.3331 8 7.11089 8 4.88867C8 2.66645 6.22222 0.888672 4 0.888672ZM4 6.66645C3.02222 6.66645 2.22222 5.86645 2.22222 4.88867C2.22222 3.91089 3.02222 3.11089 4 3.11089C4.97778 3.11089 5.77778 3.91089 5.77778 4.88867C5.77778 5.86645 4.97778 6.66645 4 6.66645Z" fill="#F68633" />
                    </svg>
                    <span>{premproject?.sub_locality_name}, {premproject?.locality_name}</span>
                  </p>

                  <ul className="proul">
                    {premproject?.types && premproject?.types.length > 0 && (
                      <li>{premproject?.types?.filter(value => value !== '')?.map(value => value.toString().slice(0, 8)).join(", ")} {["apartment","villa"].includes(premproject?.property_type) 
                        ? `BHK ${premproject?.property_type}` 
                        : premproject?.property_type}</li>
                    )}
                     {premproject?.sizes && premproject?.sizes.length > 0 && (
                      <li>
                        {premproject?.sizes.length === 1
                          ? `${premproject.sizes[0]} SQ.FT (${premproject?.property_type == 'plot' ? 'Plot Area': 'Build Up'})`
                          : `${premproject.sizes[0]} - ${premproject.sizes[premproject.sizes.length - 1]} SQ.FT (${premproject?.property_type == 'plot' ? 'Plot Area': 'Build Up'})`}
                      </li>
                    )}

                      {premproject?.amenities && premproject.amenities.length > 0 && (
                      premproject.amenities.slice(0, 2).map((amenity, index) => (
                        <li key={index}>{amenity.name}</li>
                      ))
                    )}

                          
                    </ul>
                </div>



              </div>

              {/* <div className="primimgbox">
              <img src={premproject.images?.[0]} onError={(e) => { e.target.onerror = null; e.target.src = noImage; }} />
              </div> */}

              <div className="primimgbox" style={{ backgroundImage: `url(${premproject.images?.[0]})` }}>
                <div className='prim-share'>
                  <Wishlisted  data={premproject} wishlist={wishlist} user={user} token={token} handleDispatch={handleDispatch} handleOpenModal={handleOpenModal} />
                </div>
              </div>

              
            </div>

            <div className='commercialLeaseBottom'>
            {/* <Link to={`/lease-pid-${premproject?.project_id}`}  className="details"> */}
            <div onClick={() => handleLinkClick(premproject)}  className="details">
                  <button className="btn" type="button">
                    <span>Explore</span>
                  </button>
                {/* </Link> */}
                </div>
              <div className="protitle">
              <h4>
                    {/* <i className="fa fa-rupee"></i> */}
                  {showPrice(premproject.property_price)}</h4>
              </div>
            </div>
          </div>
                ))
              )}
            
         
          </Slider>
          </div>
        </div>
        {showAlertModal && 
      
        <AlertModal />
      }
      </section>
      )}
        </>
    )
}

export default CommercialLease
